import React, { Component } from 'react';
import gi1 from '../assets/gi1.png';
import logo2 from '../assets/logo2.png';

class ShopGi extends Component {
  render() {
    return (
      <div className="ShopShirts">
        <h1>Thai-Aikikai Shop's Gi</h1>

        <img className="gi1" src={gi1} alt="gi1" />
        <h2>Gi no.1</h2>
        <br />

        <div>
          please click to order
        </div>
        <br />

        <div>Powered by</div>
        <img className="logo2" src={logo2} alt="New Wave Consulting Group" />
        <div>New Wave Consulting Group</div>
      </div>
    );
  }
}

export default ShopGi;
